import { createAsyncThunk } from "@reduxjs/toolkit";
import { setCompanyInfo as setCompanyInfoReducer } from "../reducers/billingReducer";
import { getClientSecrets } from "./authActions";
import { transformClientDataToOffice } from "../../transformers/office/egressTransformer";
import { transformUsagesDataFromOffice } from "../../transformers/office/ingressTransformer";
import { api, customApi } from "../../utils/api";


export const fetchUsages = createAsyncThunk(
  "billing/fetchUsages",
  async ({ month, year } = {}, { dispatch, rejectWithValue }) => {
    try {
      // Defaults to current month/year if not provided
      const now = new Date();
      const selectedMonth = month ?? now.getMonth() + 1; // JS months are 0-based
      const selectedYear = year ?? now.getFullYear();

      const response = await customApi.get(`/usages?month=${selectedMonth}&year=${selectedYear}`);
      if(!response || !response.data || !response.data.usage) return []
      const usages = transformUsagesDataFromOffice(response.data);
      return usages;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch usage data."
      );
    }
  }
);

export const updateCompanyInfo = createAsyncThunk(
  "billing/updateCompanyInfo",
  async (companyInfo, { dispatch, rejectWithValue }) => {
    try {
      const { clientId } = getClientSecrets();

      const dataToSend = transformClientDataToOffice({
        companyInfo: companyInfo,
      });

      await api.patch(`/clients/${clientId}`, {
        companyInfo: dataToSend.companyInfo,
      });

      dispatch(setCompanyInfoReducer(companyInfo));
    } catch (error) {
      console.error("updateCompanyInfo | error: ", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update billing info."
      );
    }
  }
);
